<template>
  <div>
    <nav class="navbar is-fixed-top" role="navigation">
      <div class="container ">
        <div class="navbar-brand">
          <router-link class="navbar-item" to="/">
            <img src="../../../assets/images/logo.png" alt="UltraShop.uz - Каждому по ноутбуку!" width="256"
                 height="48">
          </router-link>
          <div class="navbar-burger burger" data-target="navbarExampleTransparentExample">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <div id="navbarExampleTransparentExample" class="navbar-menu">
          <div class="navbar-end">
            <a class="navbar-item" :href="'tel:'+contacts.phone_number">
              <img src="../../../assets/images/social/phone.png" width="16">
              <span class=" has-text-weight-bold">&nbsp; {{ contacts.phone_number }}</span>
            </a>
            <a class="navbar-item" :href="'https://telegram.me/'+contacts.telegram_username" target="_blank">
              <img src="../../../assets/images/social/telegram.png" width="16">
              <span class=" has-text-weight-bold">&nbsp; @{{ contacts.telegram_username }}</span>
            </a>
          </div>
        </div>
      </div>
    </nav>
    <div style="margin-top: 20px;margin-bottom: 20px">
      <div class="container">
        <Search/>
      </div>
    </div>
  </div>
</template>
<script>

import Search from "../Search";
import axios from "axios";

export default {
  name: "HeaderBF",
  components: {Search},
  props: {
    perks: []
  },
  data() {
    return {
      brands: [],
      laptopTypes: [],
      API_URL: process.env.VUE_APP_API_URL,
      contacts: {
        phone_number: '',
        telegram_username: '',
      },
    }
  },
  methods: {
    fetchPhoneNumber() {
      axios.get(this.API_URL + '/dollar/phone')
          .then(response => {
            this.contacts.phone_number = response.data[0].phone_number
            this.contacts.telegram_username = response.data[0].telegram_username
          })
    },
  },
  created() {
    this.fetchPhoneNumber()
    document.addEventListener('DOMContentLoaded', () => {

      // Get all "navbar-burger" elements
      const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

      // Check if there are any navbar burgers
      if ($navbarBurgers.length > 0) {

        // Add a click event on each of them
        $navbarBurgers.forEach(el => {
          el.addEventListener('click', () => {

            // Get the target from the "data-target" attribute
            const target = el.dataset.target;
            const $target = document.getElementById(target);

            // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
            el.classList.toggle('is-active');
            $target.classList.toggle('is-active');

          });
        });
      }

    })
  }
}
</script>
<style scoped>
.navbar-item img {
  max-height: 256px;
}
</style>
